import React from 'react';
import AiDisclaimer from './AiDisclaimer';

const RATING_CLASS = {
  FAVORABLE: 'matchup-rating--favorable',
  NEUTRAL:   'matchup-rating--neutral',
  TOUGH:     'matchup-rating--tough',
};

/**
 * Week-by-week matchup preview panel for S2 use case.
 *
 * @param {Object}   props
 * @param {string}   props.playerName
 * @param {string}   props.position
 * @param {string}   props.team
 * @param {string}   props.outlook       - Overall outlook: FAVORABLE | NEUTRAL | TOUGH
 * @param {Array}    props.weekBreakdown - Array of { week, opponent, rating }
 * @param {string}   props.summary       - One-sentence narrative
 * @param {string}   props.dataAsOf     - ISO timestamp for AiDisclaimer
 * @param {Function} [props.onClose]    - Optional close handler
 */
export default function MatchupPreviewPanel({
  playerName, position, team, outlook, weekBreakdown, summary, dataAsOf, earlyAccess, onClose,
}) {
  return (
    <div className="matchup-panel">
      <div className="ai-suggestion-panel-header">
        <span className="ai-suggestion-panel-title">✦ Matchup Preview</span>
        {onClose && (
          <button className="ai-suggestion-panel-close" onClick={onClose} aria-label="Close">
            ✕
          </button>
        )}
      </div>

      <p className="matchup-panel-player">
        <strong>{playerName}</strong>
        <span className="matchup-panel-meta"> · {position}, {team}</span>
        <span className={`matchup-badge ${RATING_CLASS[outlook] || ''}`} style={{ marginLeft: 8 }}>
          {outlook}
        </span>
      </p>

      {summary && <p className="matchup-panel-summary">{summary}</p>}

      {weekBreakdown && weekBreakdown.length > 0 && (
        <table className="matchup-panel-table">
          <thead>
            <tr>
              <th>Week</th>
              <th>Opponent</th>
              <th>Rating</th>
            </tr>
          </thead>
          <tbody>
            {weekBreakdown.map((row, i) => (
              <tr key={i}>
                <td>Wk {row.week}</td>
                <td>{row.opponent}</td>
                <td>
                  <span className={`matchup-rating ${RATING_CLASS[row.rating] || ''}`}>
                    {row.rating}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <AiDisclaimer dataAsOf={dataAsOf} earlyAccess={earlyAccess} />
    </div>
  );
}
